
/* injects from baggage-loader */

const moduleImageInitializer = angular.module('image.initializer', []);

moduleImageInitializer.service('ImageInit', [
  "$timeout", "$injector", "ns", "$translate",
  ($timeout, $injector, ns, $translate) => {
    let Y = undefined;
    const image = {
      init: function(y) {
        Y = y;
        this.initImages();
      },
      resizers: [],

      updateOptions: function(widget) {
        const options = window.justclick;
        const linkHref = widget.image_attributes.link_href;
        const isDefaultValue = linkHref === '' || linkHref === '#' || linkHref === null;

        if (options && options.useNextPageUrl && isDefaultValue) {
          widget.image_attributes.link_href_target = 'next';
          widget.image_attributes.link_href = '#nextPage';
        }
      },

      findImagesForLazyLoad: function() {
        this.images = $("img.lazy");
      },
      showImage: function(index, image) {
        const $image = $(image);
        const src = $image.data('src');

        $image.attr('src', src);
      },
      initImages: function() {
        this.findImagesForLazyLoad();
        this.images.each(this.showImage);
      },
      destroy: function() {}
    };
    return image;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/image/image.initializer.js